import React, { FC, useEffect, useRef } from 'react';
import './ribbon.scss';
import { RibbonSvg } from './svg';
export type RibbonProps = {
  ribbonColor: string;
  textColor: string;
  text: string;
  size?: 'lg' | 'sm';
};

export const RibbonLarge: FC<RibbonProps> = ({ text, textColor, ribbonColor }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      const lines = Math.ceil(ref.current.clientHeight / 14);
      const svg = ref.current.parentElement?.firstElementChild as SVGElement;
      svg.setAttribute('height', `${12 + lines * 14}px`);
    }
  }, [text]);
  return (
    <div className={`hl-ribbon hl-ribbon-lg`}>
      <RibbonSvg color={ribbonColor} />
      <div className="ribbon-text-container" ref={ref} style={{ color: textColor }}>
        <div className="inner-text">{text}</div>
      </div>
    </div>
  );
};

export const RibbonSmall: FC<RibbonProps> = ({ text, textColor, ribbonColor }) => {
  return (
    <span
      className={`hl-ribbon hl-ribbon-sm badge`}
      style={{ backgroundColor: ribbonColor, borderColor: ribbonColor, color: textColor }}
    >
      {text}
    </span>
  );
};

export const Ribbon: FC<RibbonProps> = ({ size = 'lg', ...props }) => {
  if (size === 'lg') {
    return <RibbonLarge {...props} />;
  } else {
    return <RibbonSmall {...props} />;
  }
};

export default Ribbon;
